import { ApiService } from 'app/services/api.service';

export async function getDownloadPdfFile(
  link: string,
  name: string,
  password?: string
) {
  const response = password
    ? await ApiService.getProtectedPdf(link, password)
    : await ApiService.getPdf(link);

  const blob = new Blob([response.data], {
    type: 'application/pdf',
  });

  const contentDisposition = response.headers['content-disposition'];
  const fileName = contentDisposition
    ? contentDisposition
        .replace('inline; filename="', '')
        .replace('attachment; filename="', '')
        .replace('"', '')
    : name;

  const tempLink = document.createElement('a');
  tempLink.href = window.URL.createObjectURL(blob);
  tempLink.download = fileName;
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
}
